import React from 'react';
import PropTypes from 'prop-types';
import StyledFieldLabel, {StyledFieldLabelAsterisk} from './FieldLabel.styled';

function FieldLabel({content = undefined, required = false}) {
  if (!content) {
    return '';
  }
  return (
    <StyledFieldLabel>
      <span>{content}</span>
      {required && <StyledFieldLabelAsterisk>*</StyledFieldLabelAsterisk>}
    </StyledFieldLabel>
  );
}

FieldLabel.propTypes = {
  content: PropTypes.node,
  required: PropTypes.bool,
};

export default FieldLabel;
